// extracted by mini-css-extract-plugin
module.exports = {"title":"_7eca0d8e52e4de9eb6a35e44295b9255-less"};